// extracted by mini-css-extract-plugin
module.exports = {"testcard":"CookieNotification_testcard__5clnm"};